// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ProgressBar from '../common/ProgressBar';
import RadioButton from '../common/RadioButton';
import { FormattedNumber } from 'react-intl';
import { makeGetAreaSourcesProgress } from '../../selectors/dsa/sourcesSelectors';
// css
import '../../styles/components/analytics/OverlapAreaListItem.scss';


class OverlapAreaListItem extends Component {

  render() {
    const {area, progress, selected} = this.props;
    const percentComplete = (progress.current / progress.total);

    return (
      <div className='analytics__overlap-area-list-item area-overlap-bar'>
        <div className='row'>
          <div className='col-md-2 analytics__overlap-area-list-item__radio-button-container'>
            <RadioButton checked={selected} />
          </div>
          <div className='col-md-10 analytics__overlap-area-list-item__progress-bar-container'>
            <h5 className='item-title'>{area.title}</h5>
            <ProgressBar percent={percentComplete} />
            <div className='analytics__overlap-area-list-item__meta'>
              Data Input <FormattedNumber value={percentComplete} style='percent' /> Complete
            </div>
          </div>
        </div>
      </div>
    );
  }
}

OverlapAreaListItem.propTypes = {
  area: PropTypes.object,
  selected: PropTypes.bool,
  progress: PropTypes.object
};

const mapStateToProps = (state, props) => {
  const getAreaSourcesProgress = makeGetAreaSourcesProgress();
  return {
    progress: getAreaSourcesProgress(state, props)
  };
};

export default connect(mapStateToProps)(OverlapAreaListItem);



// WEBPACK FOOTER //
// ./src/components/analytics/OverlapAreaListItem.js